import type { TSelectProps } from '@okam/shared-ui'
import { SelectReactAria } from '@okam/shared-ui'
import type { TSelectReactAriaProps } from '@okam/shared-ui/src/components/fields/Select/components/SelectReactAria/SelectReactAria.interface'
import type { Key } from 'react'
import tw, { css } from 'twin.macro'  /* eslint-disable-line */
import { buttonStyles, getPopoverStyles } from './styles'

const FilterReactAria = (props: TSelectReactAriaProps<TSelectProps>) => {
  const {
    disabled = false,
    isError = false,
    errorMessage,
    children,
    placeholderLabel,
    ariaLabel,
    onSelectionChange,
    selectedKey,
    popoverStyles,
  } = props

  const handleChange = (value: Key) => {
    if (onSelectionChange) {
      onSelectionChange(value)
    }
  }

  return (
    <div css={buttonStyles}>
      <SelectReactAria
        id="filter"
        name="filter"
        placeholderLabel={placeholderLabel}
        disabled={disabled}
        isError={isError}
        errorMessage={errorMessage}
        popoverStyles={css`
          ${getPopoverStyles()}
          ${popoverStyles}
        `}
        ariaLabel={ariaLabel}
        onSelectionChange={handleChange}
        selectedKey={selectedKey}
      >
        {children}
      </SelectReactAria>
    </div>
  )
}

export default FilterReactAria
